// extracted by mini-css-extract-plugin
module.exports = {"content":"Settings_content__39CG2","layout":"Settings_layout__qNayh"};